import { useEffect, useState } from 'react';

/** Below Tailwind's `sm` breakpoint (phones): the JS twin of the `max-sm:` variant. */
export const BELOW_SM = '(width < 40rem)';
/** Below Tailwind's `lg` breakpoint (phones and portrait tablets): where the game stacks into one column. */
export const BELOW_LG = '(width < 64rem)';

/** Live result of a CSS media query (e.g. short viewports get a smaller table card). */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false,
  );
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener?.('change', onChange);
    return () => mql.removeEventListener?.('change', onChange);
  }, [query]);
  return matches;
}
